import { Component, OnInit, Input } from '@angular/core';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-angular';
import { CustomDeviceDetectorService } from '../../services/CustomDeviceDetectorService';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  customDeviceDetectorService: CustomDeviceDetectorService;
  isMobile: boolean;
  expanded1: boolean = false;
  expanded2: boolean = false;
  expanded3: boolean = false;

  constructor(customDeviceDetectorService: CustomDeviceDetectorService) { 
    this.customDeviceDetectorService = customDeviceDetectorService
  }

  ngOnInit() {
    this.isMobile = this.customDeviceDetectorService.isMobile();
    // remove this after implementation is done
    console.log('footer component initialized with component data', this.rendering);
  }

  expand1(){
    this.expanded1 = !this.expanded1;
  }
  expand2(){
    this.expanded2 = !this.expanded2;
  }
  expand3(){
    this.expanded3 = !this.expanded3;
  }

}
